<div *ngIf="showTable && showData" class="main-div">
  <div class="two-columns">
    <div class="row">
      <div class="column"><b>Procedure Code:</b> {{records && records.length > 0 ? records[0].procedurecode : ''}}</div>
    </div>
    <div class="row">
      <table class="styled-table">
        <thead>
          <tr>
            <th>Criteria Type</th>
            <th>Criteria #</th>
            <th>Description</th>
            <th *ngIf="this.planType != 'CSBD'">Use First</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let policy of polices;">
          <tr *ngFor="let templateId of policy.templateID;">
            <td [matTooltip]="showCriteriaToolTip(templateId.criteria)" matTooltipPosition="above" matTooltipShowDelay="300" matTooltipHideDelay="100">
              {{templateId.criteria}}
            </td>
            <td *ngIf="templateId.criteria == 'MCG'">
             {{templateId.policyNumber}}
            </td>
            <td *ngIf="templateId.criteria != 'MCG'">
              <a href={{templateId.policyLink}} target="_blank" style="cursor: pointer;">
              {{ templateId.policyNumber }}
            </a></td>
            <td>{{templateId.policyDescription}}</td>
            <td *ngIf="this.planType != 'CSBD'">{{templateId.useFirst}}</td>
          </tr>
          </ng-container>
          <!-- More rows can be added here -->
        </tbody>
      </table>
    </div>
  </div>
  <div class="two-columns">
    <div class="row">
      <table class="styled-table">
        <thead>
          <tr>
            <th>Recommended Documents</th>
            <th>LOINC Code(s)</th>
          </tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let item of records;let i=index">
          <tr>
            <td>{{ item.prediction }}</td>
            <td><span class="tooltip" style="margin-right: 10px;" *ngFor="let code of item.loinccode"
              (mouseenter)="showPLoincToolTip(code, i)" (mouseleave)="showTooltip = false">
              {{ code }}
              <div class="tooltiptext" *ngIf="showTooltip">
                <div>{{ loincDescription[0]?.loINCDescription }}</div>
              </div>
            </span></td>
          </tr>
        </ng-container>
        </tbody>
      </table>
    </div>
  </div>


  <form class="feedback-div" [formGroup]="feedbackForm">
    <div style="display: flex; flex-direction: row">
      <p class="feedback-labels" style="margin-bottom: 4px">
        Was this tool helpful?
      </p>
      <mat-radio-group aria-label="Select an option" [(ngModel)]="checkedOption" formControlName="ishelpful">
        <mat-radio-button class="radio-labels" value="Yes" role="radio" aria-label="feedback yes"
          [checked]="true">Yes</mat-radio-button>
        <mat-radio-button class="radio-labels" value="No" role="radio" aria-label="feedback no">No</mat-radio-button>
      </mat-radio-group>
    </div>
    <div>
      <p class="feedback-labels" style="margin-bottom: 4px">
        Please share your feedback and recommendations. (500 characters only)
      </p>
      <textarea class="textarea-style" maxlength="500" placeholder="Add a comment..." [(ngModel)]="commentAdded"
        formControlName="comment" [(ngModel)]="addedText" (keyup)="charactersCounter()"></textarea>
      <div style="font-family: Lato; font-size: 14px;">
        <span id="wordCount">{{ characters }} </span>remaining.
      </div>
    </div>
    <button class="submit_button" aria-describedby="submit feedback" (click)="handleSubmit()">Submit</button>
  </form>
</div>

<app-loader *ngIf="isLoading"></app-loader>